import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AboutPro } from 'src/app/core/objects/payment';
import { User } from 'src/app/core/objects/user';
import { UserService } from 'src/app/core/services/user.service';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';
import { LanguageService } from '../../core/services/language.service';
import { Router } from '@angular/router';
import { PaymentApiService } from '../../core/services/payment-api.service';

@Component({
    selector: 'gl-subscription-expire-popup',
    templateUrl: './subscription-expire-popup.component.html',
    styleUrls: ['./subscription-expire-popup.component.scss'],
    standalone: false
})
export class SubscriptionExpirePopupComponent implements OnDestroy {
  public endDatePro: string;
  public user: User;
  private subscription: Subscription;

  constructor(
    private modalRef: ModalOverlayRef,
    private paymentApiService: PaymentApiService,
    private userService: UserService,
    private router: Router,
    private languageService: LanguageService,
  ) {
    this.modalRef.backgroundClicked();
    this.user = this.userService.getState();
    this.subscription = this.paymentApiService
      .getAboutPro()
      .subscribe((aboutPro: AboutPro): void => {
        this.endDatePro = aboutPro.endPeriodDate.split('.').reverse().toString().replace(/,/g, '.');
      });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public openPriceList(): void {
    this.close(true);
    const defaultLanguage = this.languageService.getDefaultLanguage();
    this.router.navigateByUrl(`/${defaultLanguage}/account/subscription/priceList`);
  }

  public close(result: boolean) {
    this.modalRef.close(result);
  }
}
